import React from 'react';
import { CompanySection } from '../../proposal/sections/dach/CompanySection';
import { BenefitsSection } from '../../proposal/sections/dach/BenefitsSection';
import { PageFooter } from '../../proposal/primitives/PageFooter';
import { DraggableElement } from '../../DraggableElement';
import { DACH_DATA } from '../../proposal/data/dachData';

// Re-export für ContentPage3/4Dach (die importieren PageFooterDach von hier).
export const PageFooterDach = ({ page }) => <PageFooter page={page} />;

/**
 * Page 2 (A4) – Unternehmensprofil + Vorteile.
 * Composer: setzt CompanySection + BenefitsSection zusammen.
 */
export const ContentPage2Dach = ({ editMode, textEditMode = false, layoutEditLevel, proposalData = DACH_DATA, textContent, onTextChange, showMarkers = true, selectedElements, elementPositions, onSelectElement, onPositionChange }) => {
  const dragProps = {
    editMode,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
    showMarkers,
  };

  return (
    <div className="a4-page" data-testid="page-2-dach" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {layoutEditLevel === 'detail' ? (
        <CompanySection
          content={textContent?.page2?.company || proposalData.text?.page2?.company || DACH_DATA.text?.page2?.company}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S2-Unternehmensprofil" {...dragProps}>
          <CompanySection
            content={textContent?.page2?.company || proposalData.text?.page2?.company || DACH_DATA.text?.page2?.company}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      {layoutEditLevel === 'detail' ? (
        <BenefitsSection
          content={textContent?.page2?.benefits || proposalData.text?.page2?.benefits || DACH_DATA.text?.page2?.benefits}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S2-Vorteile" {...dragProps} initialStyle={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          <BenefitsSection
            content={textContent?.page2?.benefits || proposalData.text?.page2?.benefits || DACH_DATA.text?.page2?.benefits}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      <PageFooterDach page={2} />
    </div>
  );
};
